module.exports = "/packs/images/homepage/facilities/leisure_tablet~c42448bfbcac824f366ed5b51b7d3d0b.jpg";